import { render, staticRenderFns } from "./ChooseClientIdentifierDocumentItem.vue?vue&type=template&id=63464180&scoped=true&"
import script from "./ChooseClientIdentifierDocumentItem.vue?vue&type=script&lang=js&"
export * from "./ChooseClientIdentifierDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=63464180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63464180",
  null
  
)

export default component.exports